import { AddToastType, RemoveToastType } from './toast.actions';

const initialState = {
  data: [],
};

export const toastReducer = (state = initialState, action) => {
  switch (action.type) {
    case AddToastType:
      return {
        ...state,
        data: [...state.data, action.payload],
      };

    case RemoveToastType:
      return {
        ...state,
        data: state.data.filter(({ id }) => id !== action.payload.id),
      };

    default:
      return state;
  }
};
